// extracted by mini-css-extract-plugin
var _1 = "EditorComment_content__36921";
var _2 = "EditorComment_root__22348";
var _3 = "EditorComment_title__4a0dd";
export { _1 as "content", _2 as "root", _3 as "title" }
